var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowClockwiseBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 7v6a1.5 1.5 0 01-1.5 1.5h-6a1.5 1.5 0 110-3h2.137l-2.375-2.173A9.5 9.5 0 1015.875 25.5H16a9.44 9.44 0 006.519-2.59 1.501 1.501 0 012.061 2.182A12.431 12.431 0 0116 28.5h-.171a12.5 12.5 0 118.985-21.368L27.5 9.59V7a1.5 1.5 0 113 0z"
  })));
}
export default SvgArrowClockwiseBold;